import { GetHerbsForRecepyCsv } from "../../functions/getHerbsForRecepy"

export const HerbWikiCsv = (dataSource) => {
    return {
    fileName: "Wiki herb list",
    headers: [
      {
        label: 'Item id',
        key: 'itemId', 
      },
      {
        label: 'Name',
        key: 'name', 
      }       
    ], 
    data: dataSource.map(_ =>  {return {
      itemId: _.item?.id,
      name: _.item?.name
    }})
  }
}

export const PotionWikiCsv = (dataSource) => {
    return {
    fileName: "Wiki potion list",
    headers: [
      {
        label: 'Item id',
        key: 'itemId', 
      },
      {
        label: 'Name',
        key: 'name', 
      },
      {
        label: 'Description',
        key: 'description', 
      }          
    ], 
    data: dataSource.map(_ =>  {
    const description = JSON.parse(_.item.description);
    return {
      itemId: _.item?.id,
      name: _.item?.name,
      description: description && description?.ops[0].insert
    }})
  }
}

export const PotionRecepyWikiCsv = (dataSource) => {
    return {
    fileName: "Wiki recepy list",
    headers: [
      {
        label: 'Item id',
        key: 'itemId', 
      },
      {
        label: 'Potion',
        key: 'name', 
      },
      {
        label: 'Herbs',
        key: 'herbs', 
      },
      {
        label: 'Discovered by',
        key: 'discoverdBy', 
      }             
    ], 
    data: dataSource.map(_ =>  {
    return {
      itemId: _.potion?.item?.id,
      name: _.potion?.item?.name,
      herbs: GetHerbsForRecepyCsv(_),
      discoverdBy: _.discoverdBy
    }})
  }
}